import React, { Component } from 'react'
import AriaModal from 'react-aria-modal'

import styles from './styles.module.scss'
import './index.global.scss'
import {
  CardItemContainer,
  CardContainer,
  CardImage,
  MobileSlider,
  MobileContainer,
  KnowMoreButton,
  CardImageContainer,
  MembershipCardImage,
  PointContentWrapper,
  Point,
  VisitText,
  ImageModalWrapperContainer,
  ImageContentContainer,
  CloseButton,
  CloseImage
} from './styledComponents'

class MobilePriceCards extends Component {
  constructor(props) {
    super(props)
    this.state = { modalStatus: false }
  }

  handleOpenModal = () => {
    this.setState({ modalStatus: true })
  }

  handleCloseModal = () => {
    this.setState({ modalStatus: false })
  }

  renderMembershipModal = ({
    imageUrl,
    imageAltText,
    visitArcadeText,
    packageText
  }) => {
    const { modalStatus } = this.state
    return (
      <AriaModal
        titleId="custom-modal"
        underlayClass={styles.dialogStyle}
        focusDialog
        mounted={modalStatus}
        ariaHideApp={false}
        onExit={this.handleCloseModal}
      >
        <CloseButton
          type="button"
          className={styles.closeButton}
          aria-label="Close"
          onClick={this.handleCloseModal}
        >
          <CloseImage
            src="https://cdn.zeplin.io/5b9ba4851a546d689032f416/assets/11D7F9E7-5526-4A37-B8F9-3A3AD77CA0C2.svg"
            alt="close-icon"
            id="close-icon-membership-card-mobile"
          />
        </CloseButton>
        <ImageContentContainer>
          <MembershipCardImage
            id={imageAltText}
            src={imageUrl}
            alt={imageAltText}
          />
          <PointContentWrapper>
            <Point />
            <VisitText>{visitArcadeText}</VisitText>
          </PointContentWrapper>
          {packageText ? (
            <PointContentWrapper>
              <Point />
              <VisitText>{packageText}</VisitText>
            </PointContentWrapper>
          ) : null}
        </ImageContentContainer>
      </AriaModal>
    )
  }

  render() {
    const { openSBForm, priceCardsData } = this.props
    const { priceCardsMobileImagesList } = priceCardsData

    const isOnlyOnePriceCardPresent = priceCardsMobileImagesList.length === 1

    return (
      <MobileSlider>
        <MobileContainer isOnlyOnePriceCardPresent={isOnlyOnePriceCardPresent}>
          {priceCardsMobileImagesList.map(
            ({
              imageUrl,
              altText,
              buttonText,
              buttonRedirectText,
              cardId,
              isMembershipCard,
              membershipCardModalData
            }) => (
              <CardItemContainer>
                <CardContainer>
                  {isMembershipCard ? (
                    <ImageModalWrapperContainer>
                      <CardImageContainer
                        isMembershipCard={isMembershipCard}
                        onClick={this.handleOpenModal}
                        id={cardId}
                      >
                        <CardImage src={imageUrl} alt={altText} id={cardId} />
                      </CardImageContainer>

                      {this.renderMembershipModal(membershipCardModalData)}
                    </ImageModalWrapperContainer>
                  ) : buttonText ? (
                    <CardImageContainer
                      href={buttonRedirectText}
                      target="_blank"
                    >
                      <CardImage src={imageUrl} alt={altText} id={cardId} />
                    </CardImageContainer>
                  ) : (
                    <CardImage
                      onClick={openSBForm}
                      src={imageUrl}
                      alt={altText}
                      id={cardId}
                    />
                  )}
                </CardContainer>
                {buttonText && (
                  <KnowMoreButton
                    as="a"
                    href={buttonRedirectText}
                    target="_blank"
                  >
                    {buttonText}
                  </KnowMoreButton>
                )}
              </CardItemContainer>
            )
          )}
        </MobileContainer>
      </MobileSlider>
    )
  }
}

export default MobilePriceCards



// WEBPACK FOOTER //
// ./src/components/IbcArcade/PriceCards/index.mobile.js